export default "__VITE_ASSET__Dsh2Z8Tu__"